import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Table1 from './components/Table1';
import Table2 from './components/Table2';
import Table3 from './components/Table3';
import Table4 from './components/Table4';
import Table5 from './components/Table5';
import Table6 from './components/Table6';
import Table7 from './components/Table7';
import DynamicTable from './components/DynamicTable';
import Settings from './components/Settings';
import Note from './components/Note';
import FileManager from './components/FileManager';
import './App.css';

// React Router v7 future flags to suppress warnings
const future = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

function App() {
  return (
    <AuthProvider>
      <Router future={future}>
        <div className="App">
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={
                <ProtectedRoute>
                  <Navigate to="/dashboard" replace />
                </ProtectedRoute>
              } />
              <Route path="dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="table1" element={
                <ProtectedRoute>
                  <Table1 />
                </ProtectedRoute>
              } />
              <Route path="table2" element={
                <ProtectedRoute>
                  <Table2 />
                </ProtectedRoute>
              } />
              <Route path="table3" element={
                <ProtectedRoute>
                  <Table3 />
                </ProtectedRoute>
              } />
              <Route path="table4" element={
                <ProtectedRoute>
                  <Table4 />
                </ProtectedRoute>
              } />
              <Route path="table5" element={
                <ProtectedRoute>
                  <Table5 />
                </ProtectedRoute>
              } />
              <Route path="table6" element={
                <ProtectedRoute>
                  <Table6 />
                </ProtectedRoute>
              } />
              <Route path="table7" element={
                <ProtectedRoute>
                  <Table7 />
                </ProtectedRoute>
              } />
              <Route path="table/:tableId" element={
                <ProtectedRoute>
                  <DynamicTable />
                </ProtectedRoute>
              } />
              <Route path="settings" element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              } />
              <Route path="files" element={
                <ProtectedRoute>
                  <FileManager />
                </ProtectedRoute>
              } />
              <Route path="note/:noteId" element={
                <ProtectedRoute>
                  <Note />
                </ProtectedRoute>
              } />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

